import { EPromotionType } from '../../../../repositories/auction/entities/AnnouncementsBets/CompetitionPromotionTypeInfo';
import { ECompetitorsPromotionType } from '../../../../reducers/v2';

export function mapPromotionType(competitionType: EPromotionType): ECompetitorsPromotionType {
  switch (competitionType) {
    case EPromotionType.Standard:
      return ECompetitorsPromotionType.standard;
    case EPromotionType.Premium:
      return ECompetitorsPromotionType.premium;
    case EPromotionType.Top:
      return ECompetitorsPromotionType.top;
    case EPromotionType.TopWithBet:
      return ECompetitorsPromotionType.topWithBet;
    case EPromotionType.NoPromotion:
      return ECompetitorsPromotionType.noPromotion;
    default:
      throw new Error(`Unknown competition type: ${competitionType}`);
  }
}
